export function getAutoVerticalAlignment(domRect) {
    if (!domRect) {
        return undefined;
    }
    if (domRect.top > window.innerHeight / 2) {
        return 'up';
    }
    return 'down';
}
//# sourceMappingURL=getAutoVerticalAlignment.js.map